import React from 'react';
import { MapPin, Phone, Mail, Instagram, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: 'Endereço',
      content: 'SRTV sul 701 Bloco I - Palácio da Imprensa',
      subContent: 'Brasília - DF',
      link: 'https://maps.google.com/?q=Palacio+da+Imprensa+Brasilia',
    },
    {
      icon: Phone,
      title: 'WhatsApp',
      content: '61 98553-3770',
      subContent: 'Segunda a Sexta, 9h-18h',
      link: 'https://wa.me/5561985533770',
    },
    {
      icon: Mail,
      title: 'Email',
      content: 'info@estudiohertz.com.br',
      subContent: 'Respondemos em até 24h',
      link: 'mailto:info@estudiohertz.com.br',
    },
    {
      icon: Instagram,
      title: 'Instagram',
      content: '@estudiohertz',
      subContent: 'Siga-nos para novidades',
      link: 'https://www.instagram.com/estudiohertz/',
    },
  ];

  return (
    <section id="contato" className="py-16 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#48a9a6]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#ff6b35]/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="inline-block">
            <span className="text-[#ff6b35] font-semibold text-sm uppercase tracking-wider bg-[#ff6b35]/10 px-4 py-2 rounded-full">
              Entre em Contato
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">
            Vamos <span className="text-[#ff6b35]">criar juntos?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estamos prontos para transformar suas ideias em realidade
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {contactInfo.map((info, index) => (
            <Card
              key={index}
              className="group hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-[#ff6b35]/20 cursor-pointer"
              onClick={() => window.open(info.link, '_blank')}
            >
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-[#ff6b35] to-[#48a9a6] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <info.icon className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-[#1e3a5f] mb-2">{info.title}</h3>
                <p className="text-[#ff6b35] font-semibold mb-1">{info.content}</p>
                <p className="text-sm text-gray-500">{info.subContent}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Map & Info */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.234!2d-47.8897!3d-15.7989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a3b26e3c6f5c5%3A0x5e5c5f5f5f5f5f5f!2sPal%C3%A1cio%20da%20Imprensa!5e0!3m2!1spt-BR!2sbr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Estúdiu Hertz - Palácio da Imprensa"
            ></iframe>
          </div>

          {/* Info Card */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-12 h-12 bg-[#ff6b35]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="text-[#ff6b35]" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-[#1e3a5f] mb-2">Horário de Funcionamento</h3>
                  <div className="space-y-1 text-gray-600">
                    <p>Segunda a Sexta: 9h - 18h</p>
                    <p>Sábado: Sob agendamento</p>
                    <p>Domingo: Fechado</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-100 pt-6">
                <h3 className="font-bold text-[#1e3a5f] mb-4">Localizado no Palácio da Imprensa</h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  Nosso estúdio audiovisual fica no Palácio da Imprensa, no coração de Brasília, com localização privilegiada, de fácil acesso, estacionamento próximo e infraestrutura completa para gravar podcasts, cursos online e projetos audiovisuais com qualidade profissional.
                </p>
                <button
                  onClick={() => window.open('https://wa.me/5561985533770', '_blank')}
                  className="w-full px-6 py-4 bg-gradient-to-r from-[#ff6b35] to-[#ff8555] text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Agendar Visita
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Social Proof */}
        <div className="mt-12 text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-8 bg-white rounded-2xl px-8 py-6 shadow-lg">
            <div className="text-center">
              <div className="text-3xl font-bold text-[#ff6b35]">25+</div>
              <div className="text-sm text-gray-600">Anos de Experiência</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#ff6b35]">5000+</div>
              <div className="text-sm text-gray-600">Projetos Realizados</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#ff6b35]">4.9/5</div>
              <div className="text-sm text-gray-600">Avaliação no Google</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-[#ff6b35]">100%</div>
              <div className="text-sm text-gray-600">Satisfação</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;